/*
 * Chora product page: the sticky action at the bottom of small screens.
 * <chora-sticky-action target="ID"> stays hidden while the element with that id (the main
 * buy or sign-up form) or the site footer is on screen, and shows otherwise. Without
 * JavaScript it keeps its hidden attribute, so nothing is ever covered.
 */
(function () {
  'use strict';

  if (window.customElements.get('chora-sticky-action')) return;

  class ChoraStickyAction extends HTMLElement {
    connectedCallback() {
      const target = document.getElementById(this.getAttribute('target') || '');
      if (!target || !('IntersectionObserver' in window)) return;

      this.targetVisible = true;
      this.footerVisible = false;
      this.removeAttribute('hidden');
      this.setVisible(false);

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === target) this.targetVisible = entry.isIntersecting;
          else this.footerVisible = entry.isIntersecting;
        });
        this.setVisible(!this.targetVisible && !this.footerVisible);
      });
      this.observer.observe(target);

      const footer = document.querySelector('footer');
      if (footer) this.observer.observe(footer);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.observer = null;
    }

    setVisible(visible) {
      this.toggleAttribute('data-visible', visible);
      this.toggleAttribute('inert', !visible);
      if (visible) this.removeAttribute('aria-hidden');
      else this.setAttribute('aria-hidden', 'true');
    }
  }

  window.customElements.define('chora-sticky-action', ChoraStickyAction);
})();
